// src/components/Hero.jsx
export default function Hero() {
  return (
    <section
      id="home"
      className="relative bg-cover bg-center md:bg-right h-[420px] md:h-[600px]"
      style={{ backgroundImage: "url('/images/Mask Group.png')" }}
    >
      <div className="mx-auto max-w-6xl h-full px-6 flex items-center justify-center md:justify-end">
        {/* Card alineado a la derecha (W≈643, radius=10px) */}
        <div className="w-full md:w-[643px] bg-[#DFE9F4] rounded-[10px] shadow-lg p-6 md:p-10">
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-gray-600">
            New Arrival
          </p>
          <h1 className="mt-2 text-3xl md:text-5xl font-extrabold leading-tight text-[#054C73]">
            Discover Our<br className="hidden md:block" />
            New Collection
          </h1>
          <p className="mt-4 text-gray-700">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit
            tellus, luctus nec ullamcorper mattis.
          </p>
          <button className="mt-6 inline-block rounded-full bg-[#054C73] text-white px-7 py-3 font-semibold shadow-md hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-[#054C73] focus:ring-offset-2">
            Buy Now
          </button>
        </div>
      </div>
    </section>
  );
}
